var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderIndicator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / next"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.21991 5.28175C7.15019 5.21202 7.09489 5.12925 7.05715 5.03816C7.01942 4.94706 7 4.84943 7 4.75083C7 4.65223 7.01942 4.55459 7.05715 4.4635C7.09489 4.3724 7.15019 4.28963 7.21991 4.21991C7.28963 4.15019 7.3724 4.09489 7.4635 4.05715C7.55459 4.01942 7.65223 4 7.75083 4C7.84943 4 7.94706 4.01942 8.03816 4.05715C8.12925 4.09489 8.21202 4.15019 8.28175 4.21991L13.5309 9.46908C13.6007 9.53874 13.6562 9.62149 13.694 9.71259C13.7318 9.8037 13.7512 9.90136 13.7512 10C13.7512 10.0986 13.7318 10.1963 13.694 10.2874C13.6562 10.3785 13.6007 10.4613 13.5309 10.5309L8.28175 15.7801C8.21202 15.8498 8.12925 15.9051 8.03816 15.9428C7.94706 15.9806 7.84943 16 7.75083 16C7.65223 16 7.55459 15.9806 7.4635 15.9428C7.3724 15.9051 7.28963 15.8498 7.21991 15.7801C7.15019 15.7104 7.09489 15.6276 7.05715 15.5365C7.01942 15.4454 7 15.3478 7 15.2492C7 15.1506 7.01942 15.0529 7.05715 14.9618C7.09489 14.8707 7.15019 14.788 7.21991 14.7183L11.9397 10L7.21991 5.28175Z",
    fill: "#001D3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIndicator);
export default __webpack_public_path__ + "static/media/header_indicator.85eba96c345bc2258e8c4a14ae1b5b3e.svg";
export { ForwardRef as ReactComponent };